/* @flow */
import cx from 'classnames';
import LayerWithArrow from 'components/LayerWithArrow.jsx';
import * as React from 'react';

import './styles/Hovercard.scss';

/**
 * ## Card shown via trigger.
 * ### Used to display contextual content in a layer above the app in an uninterruptive way.
 *
 * # Implementation
 *
 * Invoke with [HoverLayerTrigger](/internal/components/HoverLayerTrigger) or
 * [LayerTrigger](/internal/components/LayerTrigger).
 *
 *
 * # Common usage
 *
 * ```example
 * <HoverLayerTrigger
 *   defaultLayerShown
 *   layer={
 *     <Hovercard>
 *       <HovercardBody>
 *         Hovercard
 *       </HovercardBody>
 *     </Hovercard>
 *   }>
 *   <Button>Hover</Button>
 * </HoverLayerTrigger>
 * ```
 *
 * # Minimal children
 *
 * ```example
 * <HoverLayerTrigger
 *   defaultLayerShown
 *   layer={
 *     <Hovercard>
 *       Hovercard
 *     </Hovercard>
 *   }>
 *   <Button>Hover</Button>
 * </HoverLayerTrigger>
 * ```
 */

class Hovercard extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    ...LayerWithArrow.propTypes,
  };

  render() {
    const { children, className } = this.props;

    return (
      <LayerWithArrow
        {...this.props}
        className={cx('Hovercard', className)}
        arrowClassName="Hovercard-arrow">
        {children}
      </LayerWithArrow>
    );
  }
}

export default Hovercard;
